import { forwardRef } from 'react'
import styled from 'styled-components'
import { Typography } from '../../styles'

const StyledInput = styled.input`
    outline-style: none;
    flex-grow: 1;
    border: none;
    background: transparent;
    padding: 0;
    /* Inherits its size from whatever row it sits in, and every one of those is under 16px. */
    ${Typography.touchFieldFloor};
`

const NoStyleInput = forwardRef(
    (props: React.InputHTMLAttributes<HTMLInputElement>, ref: React.Ref<HTMLInputElement>) => (
        <StyledInput {...props} ref={ref} />
    )
)

export default NoStyleInput
